/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-09-05 18:30:23
 */

import React from 'react'
import type { ColumnType } from 'antd/es/table'

interface Department {
  id: string
  name: string
}

interface Owner {
  departments: Department[]
}

interface DataItem {
  owner: Owner[]
}

export const createDepartmentsColumns = (dataSource: DataItem[]): ColumnType<any>[] => {
  if (!dataSource || dataSource.length === 0) return []
  const departmentsLevel = Math.max(
    ...dataSource.map((item) => {
      return Math.max(...item.owner.map((o) => o.departments.length))
    })
  )

  let columns: ColumnType<any>[] = []
  const title = [
    '一级部门',
    '二级部门',
    '三级部门',
    '四级部门',
    '五级部门',
    '六级部门',
    '七级部门',
    '八级部门',
    '九级部门',
    '十级部门',
    '十一级部门',
    '十二级部门',
    '十三级部门',
    '十四级部门',
    '十五级部门',
    '十六级部门',
    '十七级部门',
    '十八级部门',
    '十九级部门',
    '二十级部门'
  ]
  for (let i = 0; i < departmentsLevel; i++) {
    columns.push({
      title: title[i],
      dataIndex: `department${i}`,
      key: `department${i}`,
      width: 120,
      render: (_: any, record: DataItem) => {
        const curLevelDepartments: Department[] = record.owner
          .map((o) => (o.departments ? o.departments[i] : null))
          .reduce((acc: Department[], cur) => {
            if (cur && acc.findIndex((a) => a.id === cur.id) === -1) {
              acc.push(cur)
            }
            return acc
          }, [])
        if (curLevelDepartments.length === 0) return null
        if (curLevelDepartments.length === 1)
          return <div>{curLevelDepartments[0].name}</div>
        return (
          <>
            {curLevelDepartments.map((d, index) => (
              <div key={index}>
                {d.name}
                {index < curLevelDepartments.length - 1 ? '、' : ''}
              </div>
            ))}
          </>
        )
      }
    })
  }
  return columns
}
